module.exports = __webpack_public_path__ + "img/other-details.7ac305b4.svg";